import { render, staticRenderFns } from "./_tournamentRefundList.vue?vue&type=template&id=a8cc7d38&scoped=true&lang=pug&"
import script from "./_tournamentRefundList.vue?vue&type=script&lang=js&"
export * from "./_tournamentRefundList.vue?vue&type=script&lang=js&"
import style0 from "./_tournamentRefundList.vue?vue&type=style&index=0&id=a8cc7d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cc7d38",
  null
  
)

export default component.exports